import Log from "@/utils/Log"

export default class InputLock {
    constructor(){
        this.stateInput = [];
        this.stateA = [];
    }

    lock(){
        this.state = [];
        let matches = document.body.querySelectorAll("input, button, textarea");
        Log.trace("Locking: " + matches.length + " input elements");
        matches.forEach(element => {
            this.stateInput.push({element, disabled: element.disabled, cursor: element.style.cursor});
            element.style['pointer-events'] = 'none';
            element.style.cursor = 'wait';
        });

        this.stateA = [];
        matches = document.body.querySelectorAll("a");
        Log.trace("Locking: " + matches.length + " <a> elements");
        matches.forEach(element => {
            this.stateA.push({element, disabled: element.getAttribute("disabled"), cursor: element.style.cursor});
            element.style['pointer-events'] = 'none';
            element.style.cursor = 'wait';
        });
        document.body.style.cursor = 'wait';

    }

    release(){
        this.stateInput.forEach(elememntStatus => {
            elememntStatus.element.style.cursor = elememntStatus.cursor;
            elememntStatus.element.style['pointer-events'] = 'auto';
        });

        this.stateA.forEach(elememntStatus => {
            elememntStatus.element.style.cursor = elememntStatus.cursor;
            elememntStatus.element.style['pointer-events'] = 'auto';
        });
        this.stateInput = [];
        this.stateA = [];
        document.body.style.removeProperty("cursor");

    }

    lockUntil(promise){
        this.lock();

        promise.finally(() => {
            this.release();
        });

        return promise;
    }
}